var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.$t("tours.title") } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c("v-action-buttons", {
                attrs: { items: _vm.getActionButtons },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "default",
                  message: _vm.objectRemoveConfirm,
                  autoCloseTimeout: 0,
                  showActionButtons: true,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "error",
                  id: "form-error",
                  message: _vm.objectError,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "error",
                  id: "form-error",
                  message: _vm.objectError,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "form",
                    {
                      staticClass: "filter filter--search",
                      attrs: { action: "", method: "POST", novalidation: "" },
                      on: { submit: _vm.onChangeResultsTableFilter },
                    },
                    [
                      _c("div", { staticClass: "filter__grid" }, [
                        _c("div", { staticClass: "filter__grid__item" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "form-field-tournumber" } },
                              [_vm._v(_vm._s(_vm.$t("tours.tournumber")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filter.tour_number,
                                  expression: "filter.tour_number",
                                },
                              ],
                              staticClass: "form-control form-control--small",
                              attrs: {
                                type: "text",
                                id: "form-field-tournumber",
                                placeholder: _vm.$t("tours.tournumber"),
                              },
                              domProps: { value: _vm.filter.tour_number },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.filter,
                                    "tour_number",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("search.from"))),
                                ]),
                                _vm._v(" "),
                                _c("v-datepicker", {
                                  staticClass:
                                    "form-control form-control--small form-control--date",
                                  attrs: {
                                    placeholder: _vm.$t("search.from"),
                                    format:
                                      _vm.$t("search.from") +
                                      " " +
                                      _vm.$helpers.dateFormat,
                                    clearButton: true,
                                    "monday-first": true,
                                    "disabled-dates":
                                      _vm.$helpers.disabledDates,
                                    language: _vm.de,
                                  },
                                  model: {
                                    value: _vm.filter.startdate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filter, "startdate", $$v)
                                    },
                                    expression: "filter.startdate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("search.till"))),
                                ]),
                                _vm._v(" "),
                                _c("v-datepicker", {
                                  staticClass:
                                    "form-control form-control--small form-control--date",
                                  attrs: {
                                    placeholder: _vm.$t("search.till"),
                                    format:
                                      _vm.$t("search.till") +
                                      " " +
                                      _vm.$helpers.dateFormat,
                                    clearButton: true,
                                    "monday-first": true,
                                    "disabled-dates": {
                                      days: [6, 0],
                                      to: new Date(_vm.filter.startdate),
                                    },
                                    language: _vm.de,
                                  },
                                  model: {
                                    value: _vm.filter.enddate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filter, "enddate", $$v)
                                    },
                                    expression: "filter.enddate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter__grid__item" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "form-field-kolonne" } },
                                [_vm._v("Kolonne")]
                              ),
                              _vm._v(" "),
                              _c("v-select-kolonne", {
                                attrs: {
                                  id: "form-field-kolonne",
                                  name: "kolonne",
                                  placeholder: _vm.$t("select_all"),
                                },
                                model: {
                                  value: _vm.filter.kolonne,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filter, "kolonne", $$v)
                                  },
                                  expression: "filter.kolonne",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button u-extra-small-margin--top",
                                attrs: {
                                  role: "button",
                                  type: "submit",
                                  title: _vm.$t("search"),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("search")))]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-table", {
                    attrs: {
                      isLoading: _vm.resultsTableLoading,
                      columns: _vm.resultsTableColumns,
                      items: _vm.resultsTableItems,
                      showHeaderRow: true,
                      showShowAll: false,
                      useDetailRow: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "tour_number",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "table-label" }, [
                              _vm._v(_vm._s(row.tour_number)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "kolonne",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.kolonne))])]
                        },
                      },
                      {
                        key: "startdate",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(row.startdate, "DD.MM.YYYY")
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "enddate",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(row.enddate, "DD.MM.YYYY")
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "update",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "button button--action button--action--edit button--small",
                                attrs: {
                                  to: {
                                    name: "update-tour",
                                    params: { tour: row.id },
                                  },
                                  title: _vm.$t("update"),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("update")))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "pdf",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button button--action button--action--pdf button--small",
                                attrs: { title: _vm.$t("generatepdf") },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.generateTourPdf(
                                      row.id,
                                      row.tour_number
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("generatepdf")))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "duplicate",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "button button--action button--action--duplicate button--small",
                                attrs: {
                                  to: {
                                    name: "duplicate-tour",
                                    params: { tour: row.id },
                                  },
                                  title: _vm.$t("duplicate"),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("duplicate")))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "delete",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button button--action button--action--delete button--small",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.onOpenDeleteDialog(
                                      row.id,
                                      row.tour_number
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-pagination", {
                    attrs: {
                      currentPage: _vm.resultsTableCurrentPage,
                      itemsPerPage: _vm.resultsTableItemsPerPage,
                      items: _vm.resultsTableItemsCount,
                    },
                    on: { pageClicked: _vm.onChangeResultsTablePage },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-pdf-dialog", {
                attrs: {
                  isVisible: _vm.pdfDialogIsVisible,
                  tourId: _vm.pdfTourId,
                  tourNumber: _vm.pdfTourNumber,
                },
                model: {
                  value: _vm.pdfDialogIsVisible,
                  callback: function ($$v) {
                    _vm.pdfDialogIsVisible = $$v
                  },
                  expression: "pdfDialogIsVisible",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }